export const colors = {
  white: "#FFFFFF",
  mainColor: "#111111",
  accentColor: "#ea6e01",
  bodyTextColor: "#333333",
  imageBackground: "#F6F8FB",
  transparent: "transparent",
  secondaryTextColor: "#666666",
  backgroundColor: "#28324a",
  backgroundColorDark: "#12172a",
  darkGrey: "#999",
  darkBg: "#1d2233",
  lightGrey: "#363d4e",
  green: "#009a2d",
  red: "#c14330",
  colorCard: "#373b4b",
};

export const theme = { colors };
